export default "__VITE_ASSET__8d3b7f6f__"